<h2 mat-dialog-title>Export {{ data.title }}</h2>

<mat-dialog-content class="te-body">
  <mat-radio-group class="te-choices" [(ngModel)]="scope" name="scope">
    <mat-radio-button value="selection" *ngIf="hasSelection">
      <span class="te-choice">
        <span class="te-choice-name">The rows you ticked</span>
        <span class="te-choice-count">{{ data.selectedCount }}</span>
      </span>
    </mat-radio-button>

    <mat-radio-button value="page">
      <span class="te-choice">
        <span class="te-choice-name">This page</span>
        <span class="te-choice-count">{{ pageLabel }}</span>
      </span>
    </mat-radio-button>

    <!-- THE THREE ARE ALWAYS OFFERED. Each was hidden when its rows came to
         the same set as the option above it - "everything" without a second
         page, "all the table" without a filter - on the reasoning that a
         choice with no consequence still costs a read. Ruled the other way on
         2026-08-30, twice: a menu that changes shape is worse than a
         redundant line in it, because somebody who saw three options once and
         two the next time has to work out what they did wrong. The counts sit
         beside the names and say when two of them are the same rows. -->
    <mat-radio-button value="all">
      <span class="te-choice">
        <span class="te-choice-name">Everything matching the filter</span>
        <span class="te-choice-count">{{ data.totalCount }}</span>
      </span>
    </mat-radio-button>

    <mat-radio-button value="table">
      <span class="te-choice">
        <span class="te-choice-name">All the table</span>
        <span class="te-choice-count">{{ tableLabel }}</span>
      </span>
    </mat-radio-button>
  </mat-radio-group>

  <!-- Said once, at the bottom, rather than on every option: reading the whole
       table is a walk through the server's pages and can take a moment. -->
  <p class="te-note" *ngIf="readsEveryPage">
    The whole table is read a page at a time before the file is written.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="br-btn br-btn--ghost" (click)="cancel()">Cancel</button>
  <button type="button" class="br-btn br-btn--primary" (click)="confirm()">
    <br-icon>download</br-icon> Export {{ rowsInScope }}
  </button>
</mat-dialog-actions>
